import * as React from "react"
import { Notification } from "gatsby-interface"
import { MdInfo } from "react-icons/md"
import { useStatusPageStatus } from "../hooks/useStatusPageStatus"

export function StatusPageBanner() {
  const data = useStatusPageStatus()
  const incident = data?.incidents?.[0]

  if (!incident) {
    return null
  }

  const message = incident?.name

  return (
    <Notification
      Icon={MdInfo}
      variant="SECONDARY"
      isOpened={true}
      content={message}
      tone="WARNING"
      linkText="More details at status page"
      linkUrl="https://status.gatsbyjs.com/"
      data-testid="statusPageBanner"
    />
  )
}
